'use client'

import React from 'react'

export const ArtistTalk = () => {
  return (
    <div className="p-[10px] flex gap-[8px] items-center w-[360px] ml-[20px] mr-[20px] h-[40px] rounded-lg border border-white/20 bg-white/20 shadow-[0_0_3px_0_rgba(0,0,0,0.25)] backdrop-blur-[17px]">
      <img src="/img/tag/artisttalk.svg" />
      <p className="text-white text-[12px] font-semibold leading-[18px]">{'여러붕~ 이제 자주 만나요!'}</p>
    </div>
  )
}
